import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Style.
 */
import './landing-menu-item.scss';

const LandingMenuItem = ({ children, active, ...rest }) => (
  <div
    {...rest}
    className={classNames('landing-menu-item-wrapper', {
      active,
    })}
  >
    <div>
      {children}
    </div>
  </div>
);

LandingMenuItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.any.isRequired,
};

LandingMenuItem.defaultProps = {
  active: false,
};

export default LandingMenuItem;
